import React from "react"
export default function Interest(){
    return(
    <div>
    <h3 className="Interest_Header">Interest</h3>
        <p className="Interest">Music Enthusiast. Anime Geek. Nature Photographer. Reader. Internet fanatic.Travel geek.</p>
    

    </div>
    )
}